import Loadable from "app/components/Loadable";
import { lazy } from "react";

const RoleList = Loadable(lazy(() => import("./RoleList")));
const RoleForm = Loadable(lazy(() => import("./RoleForm")));
const Permissions = Loadable(lazy(() => import("./Permission")));

const roleRoutes = [
  {
    path: "/Role/RoleList",
    element: <RoleList />,
  },
  {
    path: "/Role/RoleForm",
    element: <RoleForm />,
  },
  {
    path: "/Auth/permissions/byrole/:roleId",
    element: <Permissions />,
  },
  {
    path: "/Role/RoleForm/:roleId",
    element: <RoleForm />,
  },
];
export default roleRoutes;
